import React from 'react';
import { Link } from 'react-router-dom';

/** Logo — temple glyph + Devanagari wordmark "अयोध्याधाम" with the INFO suffix. */
export default function Logo({ compact = false, className = '' }) {
  return (
    <Link to="/" className={`logo${compact ? ' logo--compact' : ''}${className ? ` ${className}` : ''}`} aria-label="AyodhyaDham.info home">
      <svg className="logo__glyph" viewBox="0 0 40 40" aria-hidden="true" focusable="false">
        <path d="M20 2.5l2.2 4.2L20 10l-2.2-3.3L20 2.5Z" fill="currentColor" />
        <path d="M20 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M6 22.5L20 12l14 10.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M10.5 36V22.5M29.5 36V22.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M8 22.5h24" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M16 36v-8h8v8" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M3.5 36.5h33" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        <path d="M13 28h.01M27 28h.01" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
      </svg>
      <span className="logo__text">
        <span className="logo__word" lang="hi">अयोध्याधाम</span>
        <span className="logo__info">INFO</span>
      </span>
    </Link>
  );
}
